import { DistortApp as App } from "../work-modules/030/App";
// import "../work-modules/005/textAnimation";
// import "../work-modules/005/controls";

document.addEventListener("DOMContentLoaded", () => {
  const app = new App();
  app.initialize();
  // @ts-ignore
  (window as any).app = app;
  // app 準備完了を通知
  window.dispatchEvent(new CustomEvent("app:ready", { detail: { app } }));
});
